import React from 'react';
import ImageCarousel from './ImageCarousel';
import RenderChips from './RenderChips';

const ProjectDetails = ({ project }) => {
	if (!project) {
		return <div className="project-not-found">Project not found</div>;
	}

	const paragraphs = project.description.trim().split('\n\n');

	return (
		<div className="project-details">
			<h2>{project.title}</h2>
			
            {project.langs && <RenderChips langs={project.langs} type='lang' large/>}
            
            {project.software && <RenderChips langs={project.software} type='software' large/>}

			<div style={{marginBottom: "12px"}}>

			</div>
			<div className="project-carousel">
				<ImageCarousel projectId={project.id} />
			</div>
			
			<div className="project-description">
				{paragraphs.map((paragraph, index) => (
					<p key={index}>{paragraph.trim()}</p>
				))}
			</div>
		</div>
	);
};

export default ProjectDetails;